<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-title>Billing Statuses</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="wrapper-btn">
        <v-btn color="primary" v-if="selected.length" @click="openDialog">Gửi tin nhắn</v-btn>
      </div>
      <v-text-field
        solo
        hide-details
        prepend-inner-icon="search"
        placeholder="Tìm trên danh sách này"
        v-model="keyword"
        class="field-search"
      ></v-text-field>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="exportToExcel()">
          <v-icon>save_alt</v-icon>
        </v-btn>
        <span>Tải về</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      item-key="id"
      :headers="table.headers"
      :items="datasourceFiltered"
      :rows-per-page-items="[10,20,50,100]"
      :loading="isLoading"
    >
      <template slot="items" slot-scope="props">
        <tr @contextmenu="showContextmenu($event, props.item)">
          <td>
            <label :for="'id'+ props.item.Id" class="checkbox-custom">
              <input type="checkbox" v-model="selected" :name="'id'+ props.item.Id" :value="props.item" class="d-none checkbox-input" :id="'id'+ props.item.Id">
              <v-icon class="checkbox-icon-false">check_box_outline_blank</v-icon>
              <v-icon color="primary" class="checkbox-icon-true">check_box</v-icon>
            </label>
          </td>
          <td>{{ props.item.Id }}</td>
          <td class="no-wrap">{{ props.item.Plate }}</td>
          <td>{{ props.item.CamTime }}</td>
          <td>{{ props.item.CreatedDate }}</td>
          <td>{{ props.item.StartDate }}</td>
          <td>{{ props.item.ExpiredDate }}</td>
          <td>
            <v-icon color="orange" v-if="props.item.IsPending">check</v-icon>
          </td>
          <td>
            <v-icon color="red" v-if="props.item.IsLocked">lock</v-icon>
          </td>
          <td>{{ props.item.LockedDate }}</td>
        </tr>
      </template>
    </v-data-table>
    <dialog-send-sms ref="dialogSendSms" @success="successSendSMS"/>

    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-tile @click="openDialogSearchSim">
          <v-icon color="primary" class="pr-2">sim_card</v-icon>
          <v-list-tile-title>Tra cứu sim</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="lockSelectedVehicle">
          <v-icon color="orange" class="pr-2">lock</v-icon>
          <v-list-tile-title>Khóa xe</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="unlockSelectedVehicle"> 
          <v-icon color="green" class="pr-2">lock_open</v-icon>
          <v-list-tile-title>Mở khóa xe</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <dialog-search-sim ref="dialogSearchSim"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import validate from '@/utils/validate';
import XLSX from 'xlsx';
import DialogSendSms from '@/components/sms/DialogSendSms';
import DialogSearchSim from './DialogSearchSim';

export default {
  components: {
    DialogSendSms,
    DialogSearchSim
  },
  props: {
    name: String,
    id: Number
  },
  data () {
    return {
      table: {
        headers: [
          {
            text: '',
            value: '&nbsp;&nbsp;&nbsp;'
          },
          {
            text: 'Id',
            value: 'Id'
          },
          {
            text: 'Plate',
            value: 'Plate'
          },
          {
            text: 'CamTime',
            value: 'CamTime'
          },
          {
            text: 'CreatedDate',
            value: 'CreatedDate'
          },
          {
            text: 'StartDate',
            value: 'StartDate'
          },
          {
            text: 'ExpiredDate',
            value: 'ExpiredDate'
          },
          {
            text: 'IsPending',
            value: 'IsPending'
          },
          {
            text: 'IsLocked',
            value: 'IsLocked'
          },
          {
            text: 'LockedDate',
            value: 'LockedDate'
          }
        ]
      },
      datasource: [],
      datasourceFiltered: [],
      keyword: '',
      isLoading: false,
      selected: [],
      account: null,
      vehicleEdit: null,
      x: 0,
      y: 0,
      showMenu: false
    };
  },
  computed: {
    ...mapGetters(['searchText'])
  },
  watch: {
    keyword () {
      this.search();
    },
    selected () {
      console.log('selected', this.selected);
    }
  },
  created () {
    this.getBillingStatuses();
    if (this.id) {
      this.getAccount();
    }
  },
  methods: {
    ...mapActions(['GetCompanyBillingStatusesRequest', 'AccountRequest', 'CasesRequest', 'ContacsRequest', 'LockVehicle', 'UnlockVehicle']),
    getBillingStatuses () {
      this.isLoading = true;
      this.datasource = [];
      this.GetCompanyBillingStatusesRequest({ CompanyId: this.id })
        .then(res => {
          this.datasource = res;
          this.datasourceFiltered = res;
          if (!this.searchText.startsWith('/')) {
            this.keyword = this.searchText;
          }
        })
        .catch(_ => {
          this.datasource = [];
          this.datasourceFiltered = [];
        })
        .finally(_ => {
          this.isLoading = false;
        });
    },
    search () {
      let keywordRemovedVietnamese = validate.transferVietnamese(
        this.keyword.toLowerCase()
      );
      this.datasourceFiltered = this.datasource.filter(a =>
        validate
          .transferVietnamese(a.Plate.toLowerCase())
          .includes(keywordRemovedVietnamese.toLowerCase())
      );
    },
    exportToExcel () {
      if (this.datasourceFiltered.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      let sheet = XLSX.utils.json_to_sheet(this.datasourceFiltered);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'Billing');
      XLSX.writeFile(wb, `${this.name} - Billing.xlsx`);
    },
    openDialog () {
      if (!this.account) {
        window.getApp.showMessage('Không có thông tin CRM!', 'error');
        return;
      }
      let data = {
        account: this.account,
        list: this.selected
      };
      this.$refs.dialogSendSms.open(data);
    },
    openDialogSearchSim () {
      this.$refs.dialogSearchSim.open(this.vehicleEdit.Iccid);
    },
    getAccount () {
      this.isLoading = true;
      this.AccountRequest(this.id)
        .then(res => {
          this.account = res;
        })
        .catch(_ => {
          this.account = null;
        })
        .finally(_ => {
          this.isLoading = false;
        });
    },
    successSendSMS (success) {
      if (success) { window.getApp.showMessage('Gửi tin nhắn thành công!') }
      else { window.getApp.showMessage('Gửi tin nhắn thất bại!', 'error') }
    },
    
    showContextmenu (e, data) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.vehicleEdit = null;
      this.$nextTick(() => {
        this.showMenu = true;
        this.vehicleEdit = data;
      });
    },

    async lockSelectedVehicle () {
      let res = await this.LockVehicle(this.vehicleEdit.Id).catch(err => {
        console.log('lockSelectedVehicle -> err', err);
        window.getApp.showMessage('Khóa xe thất bại.', 'error');
        return null;
      });

      if (res) window.getApp.showMessage('Khóa xe thành công. Dữ liệu sẽ được cập nhật sau 5 phút');
    },

    async unlockSelectedVehicle () {
      let res = await this.UnlockVehicle(this.vehicleEdit.Id).catch(err => {
        console.log('unlockSelectedVehicle -> err', err);
        window.getApp.showMessage('Mở khóa xe thất bại.', 'error');
        return null;
      });

      if (res) window.getApp.showMessage('Mở khóa xe thành công. Dữ liệu sẽ được cập nhật sau 5 phút');
    }
  }
};
</script>

<style scoped>
.checkbox-sms {
  height: 24px;
}
.wrapper-btn{
  min-width: 124px;
}
.checkbox-custom{
  cursor: pointer;
  position: relative;
  height: 24px;
  width: 24px;
  display: block;
}
.checkbox-custom .v-icon{
  position: absolute;
  top: 0;
  left: 0;
}
.checkbox-input:checked ~ .checkbox-icon-false, .checkbox-icon-true{
  opacity: 0;
}
.checkbox-input:checked ~ .checkbox-icon-true, .checkbox-icon-false{
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/pages/search/components/BillingStatuses.vue